var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssignment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 38 23",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.833,
    y: 0.667,
    width: 14.5,
    height: 9.333,
    rx: 1,
    fill: "#A8FFF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11.333,
    width: 10,
    height: 2.667,
    rx: 1,
    fill: "#CBFF88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 16,
    width: 6.667,
    height: 2.667,
    rx: 1,
    fill: "#CBFF88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M11.667 9.333h10v8h-10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.377 11.724a.29.29 0 01.268.185.31.31 0 01-.063.328l-3.543 3.675a.282.282 0 01-.316.065.301.301 0 01-.179-.277v-3.675c0-.167.13-.301.29-.301h3.543zm-3.253 3.25l2.553-2.649h-2.553v2.649zM23.352 5.312a.926.926 0 000-1.275l-.486-.504a.848.848 0 00-1.23 0l-1.1 1.142 1.715 1.78 1.101-1.143zm-.896 1.78a.283.283 0 01-.41 0l-2.125-2.205a.309.309 0 010-.425l1.306-1.355a1.413 1.413 0 012.05 0l.485.504a1.544 1.544 0 010 2.127l-1.306 1.354z",
    fill: "#14454C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.456 6.667a.309.309 0 010 .425l-4.251 4.41a.288.288 0 01-.134.08l-2.834.745a.284.284 0 01-.276-.078.31.31 0 01-.076-.286l.708-2.951a.305.305 0 01.076-.14l4.252-4.41a.283.283 0 01.41 0l2.125 2.205zm-6.32 2.57l-.572 2.384 2.287-.603 3.99-4.138-1.715-1.78-3.99 4.138z",
    fill: "#14454C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.583 3.639c.16 0 .29.134.29.3 0 .167-.13.301-.29.301h-4.67V15.4h8.921c.16 0 .29.135.29.3 0 .167-.13.301-.29.301h-9.21a.295.295 0 01-.29-.3V3.94c0-.167.13-.301.29-.301h4.959zM24.087 12.024v-2.94c0-.166.13-.3.29-.3.16 0 .29.134.29.3v2.94c0 .166-.13.301-.29.301a.295.295 0 01-.29-.3z",
    fill: "#14454C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 0l.99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99L34.5 0zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99L3.5 16z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/ai-assignment-6103776d2ac4afc219b5ad0e3363e8d5.svg";
export { SvgAiAssignment as ReactComponent };